import { useState, useEffect } from 'react'
import { X, Cookie } from 'lucide-react'
import { useSearchParams } from 'react-router-dom'

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  useEffect(() => {
    const showCookies = searchParams.get('showCookies')
    if (showCookies === 'true') {
      setIsVisible(true)
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev)
        newParams.delete('showCookies')
        return newParams
      }, { replace: true })
      return
    }

    const cookieConsent = localStorage.getItem('cookieConsent')
    if (!cookieConsent) {
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 1500)
      return () => clearTimeout(timer)
    }
  }, [searchParams, setSearchParams])

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted')
    setIsVisible(false)
    window.dispatchEvent(new Event('jokic-cockpit-consent'))
  }

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined')
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className="cookie-banner fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        <div className="relative bg-gray-900/95 rounded-xl shadow-2xl border border-white/10 p-6 md:p-8">
          <div className="absolute inset-0 bg-gradient-to-br from-white/[0.02] to-transparent pointer-events-none rounded-xl" />
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-500 to-transparent" />

          <div className="relative z-10">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
              <div className="flex-shrink-0">
                <div className="p-3 rounded-lg bg-brand-600/20 border border-brand-500/30">
                  <Cookie className="h-6 w-6 text-brand-400" />
                </div>
              </div>

              <div className="flex-1">
                <h3 className="font-serif text-xl md:text-2xl font-light text-white mb-2">
                  Cookie-Einstellungen
                </h3>
                <p className="text-sm md:text-base text-gray-300 leading-relaxed">
                  Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten.
                  Durch die Nutzung unserer Website stimmen Sie der Verwendung von Cookies zu.
                  Weitere Informationen finden Sie in unserer{' '}
                  <a
                    href="/datenschutz"
                    className="text-brand-400 hover:text-brand-300 underline transition-colors"
                  >
                    Datenschutzerklärung
                  </a>.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                <button
                  type="button"
                  onClick={handleDecline}
                  className="px-6 py-3 bg-transparent border border-white/20 text-white rounded-xl hover:border-white/30 hover:bg-white/5 active:scale-[0.98] transition-all duration-200 text-sm font-medium"
                >
                  Ablehnen
                </button>
                <button
                  type="button"
                  onClick={handleAccept}
                  className="px-6 py-3 bg-brand-600 border border-brand-500/30 text-white rounded-xl hover:bg-brand-500 active:scale-[0.98] transition-all duration-200 shadow-lg shadow-brand-600/20 text-sm font-medium"
                >
                  Akzeptieren
                </button>
              </div>
            </div>
          </div>

          <button
            type="button"
            onClick={handleDecline}
            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-white transition-colors rounded-lg hover:bg-white/5"
            aria-label="Schließen"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  )
}
